// @ts-strict-ignore
import React, { FC } from 'react'
import { RouteComponentProps } from 'react-router'
import WithContainerRoute from 'mobile_web/modules/common/hocs/container-route'
import CodeRedeem from '../components/CodeRedeem'

interface MatchParams {
	code?: string
	itemId?: string
	itemType?: string
}

const CodeRedeemRoute: FC<RouteComponentProps<MatchParams> & { autoRedeem?: boolean }> = props => (
	<CodeRedeem {...props} />
)

export default WithContainerRoute(CodeRedeemRoute)
